import { jsx as o, jsxs as O } from "react/jsx-runtime";
import i, { useState as T, useEffect as w } from "react";
import { u as d } from "./index-6a632112.mjs";
import { Q as x, s as r, r as z, d as L, l as k, B as S } from "./themes-5f0b3c3d.mjs";
import { f as _ } from "./fontWeights-a25f8f91.mjs";
import { l as M } from "./lineHeights-72d3110c.mjs";
import { t as m } from "./textStyles-42cab346.mjs";
import { z as E } from "./zIndices-d07533f3.mjs";
import { a as D, b as F } from "./superScript-393c70dc.mjs";
import { S as R } from "./pause-316ed38b.mjs";
import { S as W } from "./playFilled-b880efda.mjs";
import { IconButton as U } from "./iconButton.js";
import { useWindowDimensions as j } from "./useWindowDimensions.js";
import { h as G } from "./hTag-40b23797.mjs";
import { ScreenReaderOnly as N } from "./screenReaderOnly.js";
import { MediaDisclosureButton as X } from "./mediaDisclosureButton.js";
import "./types-b577bf77.mjs";
import "./button.js";
import "./accessibility.js";
const Y = "50%", K = "70%", Q = "485px", q = "253px", J = "345px", Z = "320px", ee = d.div`
  ${D()}
  ${F()}
  align-items: center;
  display: flex;
  position: relative;
  height: ${Q};
  min-width: ${Z};

  @media ${x.tabletAndUp} {
    height: ${q};
  }
  @media ${x.laptopAndUp} {
    height: ${J};
  }
`, te = d.div`
  position: relative;
  z-index: ${E.contentOverVideo};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: ${r["3x"]};
  align-self: stretch;
  padding: 0px ${r["5x"]};

  @media ${x.tabletAndUp} {
    padding: 52px ${r["12x"]};
  }
  @media ${x.laptopAndUp} {
    padding: 0px ${r["12x"]};
  }
`, ne = d.div`
  position: absolute;
  top: unset;
  left: unset;
  height: 100%;
  width: 100%;
  overflow: hidden;
  background-color: ${(e) => e.theme.components.landingHeroVideo.videoBackground};
  border-radius: ${z["2x"]};
`, oe = d.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  overflow: hidden;
  background-color: transparent;
  z-index: ${E.contentOverVideo - 1};
  background: ${(e) => e.theme.components.landingHeroVideo.videoBackground};

  ${(e) => e.$isPlaying ? `opacity: ${e.$playingOpacity};` : `opacity: ${e.$pausedOpacity};`}
`, ie = d.div`
  height: 100%;
  width: 100%;

  div,
  video {
    position: relative;
    min-height: 100%;
    width: 100%;
    max-width: none;
    -o-object-fit: cover;
    object-fit: cover;
    z-index: ${E.contentOverVideo - 3};
  }
`, ae = d(G)`
  && {
    color: ${(e) => e.theme.components.landingHeroVideo.textColor};
    font-family: ${L.headline};
    font-weight: ${_.headline};
    font-size: ${m.headline.xxl.fontSize};
    line-height: ${M.xxxlarge};
    letter-spacing: ${k[0]};
  }
`, re = d.div`
  font-family: ${(e) => e.theme.typography.primaryFont};
  font-weight: ${m.body.medium.m.fontWeight};
  font-size: ${m.body.medium.m.fontSize};
  line-height: ${m.body.medium.m.lineHeight};
  letter-spacing: ${k[0]};
  color: ${(e) => e.theme.components.heroVideo.textColor};

  @media ${x.tabletAndUp} {
    font-weight: ${m.body.medium.l.fontWeight};
    font-size: ${m.body.medium.m.fontSize};
    line-height: ${m.body.medium.m.lineHeight};
  }
`, le = d.div`
  z-index: ${E.contentOverVideo};
`, de = d.div`
  display: flex;
  flex-direction: column;
  margin-top: ${r["3x"]};
  gap: ${r["6x"]};
  width: 100%;

  @media ${x.tabletAndUp} {
    display: flex;
    flex-direction: row;
    gap: ${r["7x"]};
    margin-top: ${r["3x"]};
    padding: 0px ${r["12x"]} ${r["8x"]} 0px;
    align-items: center;
    align-self: stretch;
  }
`;
function se({ children: e, ...n }) {
  return /* @__PURE__ */ o(ne, { ...n, children: e });
}
const pe = d.div`
  display: flex;
  align-items: center;
  gap: ${r["7x"]};
`;
function ce({
  children: e,
  ...n
}) {
  const t = i.Children.map(e, (a, c) => a && i.isValidElement(a) ? a : null);
  return /* @__PURE__ */ O(de, { ...n, children: [
    t && t.slice(0, t.length - 2),
    /* @__PURE__ */ O(pe, { children: [
      t && t[t.length - 2],
      t && t[t.length - 1]
    ] })
  ] });
}
function ue({
  children: e,
  ...n
}) {
  return /* @__PURE__ */ o(re, { ...n, children: e });
}
function me({ children: e, ...n }) {
  return /* @__PURE__ */ o(te, { ...n, children: e });
}
function fe({
  children: e,
  headingLevel: n = "h1",
  ...t
}) {
  return /* @__PURE__ */ o(ae, { as: n, ...t, children: e });
}
function ge({
  children: e,
  onClick: n,
  size: t = "medium",
  accessibilityOptions: a,
  ...c
}) {
  const { isPlaying: s, playbackIcon: f, handleOnClick: g, playButtonSize: u } = i.useContext(H);
  function $(h) {
    g(), n?.(h, !s);
  }
  return /* @__PURE__ */ O(le, { ...c, children: [
    /* @__PURE__ */ o(
      U,
      {
        icon: f,
        onClick: $,
        size: t || u,
        accessibilityOptions: {
          ariaLabel: `${s ? "Pause" : "Play"}`,
          ...a
        }
      }
    ),
    /* @__PURE__ */ o(N, { "aria-live": "assertive", children: s ? "Playing" : "Paused" })
  ] });
}
function he({
  videoProps: e,
  onPlay: n,
  onPause: t,
  onEnded: a,
  loopAmount: c = 0,
  pauseTime: s = -1,
  ...f
}) {
  const { defaultVideoProps: g, loopCount: u, setLoopCountFunc: $ } = i.useContext(H), {
    onPlay: h,
    onPause: v,
    loop: I,
    ref: V,
    ...B
  } = g, l = Math.floor(c);
  function b() {
    h(), n?.();
  }
  function C() {
    v(), t?.();
  }
  function P() {
    if (l > 0) {
      const y = V?.current;
      u + 1 < l ? ($(u + 1), y.currentTime = 0, y.play()) : (s >= 0 && (y.currentTime = s), y.pause());
    }
    a?.();
  }
  return /* @__PURE__ */ o(ie, { ...f, children: /* @__PURE__ */ o(
    "video",
    {
      ...B,
      loop: l > 0 ? !1 : I,
      ...e,
      onPlay: b,
      onPause: C,
      onEnded: P,
      ref: V
    }
  ) });
}
function ye({
  playingOpacity: e = Y,
  pausedOpacity: n = K,
  ...t
}) {
  const { isPlaying: a } = i.useContext(H);
  return /* @__PURE__ */ o(
    oe,
    {
      $playingOpacity: e,
      $pausedOpacity: n,
      $isPlaying: a,
      ...t
    }
  );
}
const H = i.createContext({
  defaultVideoProps: {
    loop: !0,
    ref: void 0,
    onPlay: () => {
    },
    onPause: () => {
    }
  },
  isPlaying: !1,
  playbackIcon: /* @__PURE__ */ o(W, {}),
  playButtonSize: "medium",
  handleOnClick: () => {
  },
  loopCount: 0,
  setLoopCountFunc: (e) => {
  }
});
function p({
  children: e,
  disclosureLinks: n,
  ...t
}) {
  const [a, c] = i.useState("medium"), [s, f] = i.useState(/* @__PURE__ */ o(W, {})), [g, u] = i.useState(!1), [$, h] = i.useState(0), v = i.useRef(null);
  function I() {
    f(/* @__PURE__ */ o(W, {})), u(!1);
  }
  function V() {
    f(/* @__PURE__ */ o(R, {})), u(!0);
  }
  function B() {
    const A = v?.current;
    g ? A.pause() : (h(0), A.play());
  }
  const { width: l } = j(), b = {
    right: ["108px", "108px", "20px"],
    bottom: ["14px", "14px", "14px"]
  }, [C, P] = T(0);
  w(() => {
    l > S.laptopMin ? P(0) : l < S.laptopMin && l > S.tabletMin ? P(1) : P(2);
  }, [l]), i.useEffect(() => {
    l < S.laptopMin ? c("medium") : c("large");
  }, [l]);
  const y = {
    playsInline: !0,
    autoPlay: !0,
    muted: !0,
    loop: !0,
    onPlay: V,
    onPause: I,
    ref: v
    // role: 'video',
  };
  return /* @__PURE__ */ o(ee, { ...t, children: /* @__PURE__ */ O(
    H.Provider,
    {
      value: {
        defaultVideoProps: y,
        isPlaying: g,
        handleOnClick: B,
        playbackIcon: s,
        playButtonSize: a,
        loopCount: $,
        setLoopCountFunc: h
      },
      children: [
        n && /* @__PURE__ */ o(
          X,
          {
            ...n,
            alignment: "bottom-right",
            containerPosition: {
              bottom: b.bottom[C],
              right: b.right[C]
            }
          }
        ),
        e
      ]
    }
  ) });
}
p.HeaderContainer = me;
p.VideoContainer = se;
p.Title = fe;
p.Body = ue;
p.PlaybackButton = ge;
p.CTAButtonContainer = ce;
p.VideoElement = he;
p.Overlay = ye;
export {
  p as LandingHeroVideoV1
};
